<template>
  <b-modal name="base-modal" v-model="isVisible" centered :hide-header-close="hideClose" :size="size" :hide-footer="!footerSlotExists" @shown="$emit('shown', $event)" @hidden="$emit('hidden', $event)" @hide="$emit('hide')" :no-close-on-backdrop="noCloseOnBackdrop" :no-close-on-esc="noCloseOnScape" :body-class="bodyClass">
    <loading-anim :active="$store.state.loading" fullScreen></loading-anim>
    <h5 v-if="title" v-html="title" :class="{'text-center': !titleAlignLeft}"></h5>
    <slot></slot>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'
import LoadingAnim from '@/components/utils/LoadingAnim'

export default {
  components: {
    BModal,
    BButton,
    LoadingAnim
  },
  props: {
    value: [Boolean],
    title: {
      type: String,
      required: false,
      default: ''
    },
    content: {
      type: String,
      required: false,
      default: ''
    },
    hideClose: {
      type: Boolean,
      required: false,
      default: false
    },
    hideFooter: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'lg',
      validator: (value) => {
        return ['sm', 'md', 'lg', 'xl'].includes(value)
      }
    },
    bodyClass: String,
    titleAlignLeft: Boolean,
    noCloseOnBackdrop: Boolean,
    noCloseOnScape: Boolean
  },
  data () {
    return {
      localValue: false
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    footerSlotExists () {
      return this.$slots['modal-footer']
    }
  }
}
</script>

<style lang="scss">
.modal-dialog {
  margin: auto;
}

/* [name="base-modal"] .modal-md {
  max-width: 400px !important;
} */

/* .modal-footer {
  display: none !important;
}
 */
// form{
//   text-align: center !important;
// }

.modal-body h5 {
  margin-bottom: 1.5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/base/BaseModal.vue